import React from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * "Tous / Actifs / Inactifs" filter shown above every list that has an
 * `isActive` flag. Controlled: `value` is 'all' | 'active' | 'inactive'.
 * Pair with `applyActiveFilter(rows, value)` to filter the rows client-side.
 */
export const applyActiveFilter = (rows, filter) => {
  if (!Array.isArray(rows)) return [];
  if (filter === 'active') return rows.filter((r) => r.isActive !== false);
  if (filter === 'inactive') return rows.filter((r) => r.isActive === false);
  return rows;
};

const ActiveFilter = ({ value, onChange, sx }) => {
  const { t } = useTranslation();
  return (
    <ToggleButtonGroup
      size="small"
      exclusive
      value={value}
      // MUI passes null when the selected button is clicked again — keep the current value.
      onChange={(_, next) => next && onChange(next)}
      sx={sx}
    >
      <ToggleButton value="all">{t('common.filterAll')}</ToggleButton>
      <ToggleButton value="active">{t('common.filterActive')}</ToggleButton>
      <ToggleButton value="inactive">{t('common.filterInactive')}</ToggleButton>
    </ToggleButtonGroup>
  );
};

export default ActiveFilter;
